








import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class GongyiDetail extends Vue {
  showTencentTips() {
    this.$emit('showTencentTips');
  }
}
